import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { dashboardService } from '../api/dashboard.service';

export function useDashboardOverview() {
  const query = useQuery({
    queryKey: queryKeys.dashboard.overview(),
    queryFn: () => dashboardService.loadStats(),
    staleTime: 30_000,
  });
  return {
    stats: query.data?.stats ?? null,
    recentSubscriptions: query.data?.recentSubscriptions ?? [],
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    loadStats: () => { void query.refetch(); },
  };
}
